export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/apps/music_videos.0727a06.svg";